import React from 'react'
import PropTypes from "prop-types"
import { Suspense, lazy } from 'react'
import Loading from '../common/Loading'
import { PackagesProvider } from '../contexts/PackagesContext'
import { PackagesModalProvider } from '../contexts/PackagesModalContext'
import { StatusModalProvider } from '../contexts/StatusModalContext'
const PackagesSearch = lazy(() => import('./PackagesSearch'))

const PackagesPage = ({ packages, destinations, lowestStay }) => {
  return(
    <PackagesProvider>
      <StatusModalProvider>
        <PackagesModalProvider>
          <Suspense fallback={<Loading />}>
            <PackagesSearch
              packages={ packages }
              destinations={ destinations }
              lowestStay={lowestStay} />
          </Suspense>
        </PackagesModalProvider>
      </StatusModalProvider>
    </PackagesProvider>
  )
}

PackagesPage.propTypes = {
  packages: PropTypes.object,
  destinations: PropTypes.array,
  lowestStay: PropTypes.number
}
export default PackagesPage
